const { checkNotEmpty } = require("./common");

export const Error = (objs, sweet) => {
    const ua = navigator.userAgent.toLowerCase();
    const isAndroid = ua.indexOf("android") > -1;
    const height = isAndroid ? "64px" : "64px";
    const contents = createContent(objs, height);
    sweet
        .fire({
            html: `
                <div id="swal-example-container">
                    <div id="header-scroll" class="revamp-error-header-container" style="height: ${height};">
                        <div></div>
                        <div class="revamp-error-header-title">
                            <h3 class="font-anuphan-bold-20 text-revamp-color-black">${objs.header}</h3>
                        </div>
                    </div>
                    ${contents}
                </div>
            `,
            showConfirmButton: true,
            showCancelButton: false,
            showCloseButton: false,
            confirmButtonText: "ตกลง",
            showClass: {
                popup: `animate__fadeSlowShow`,
            },
            hideClass: {
                popup: `animate__fadeSlowHide`,
            },
            customClass: {
                popup: "no-padding-popup transparent-popup no-max-height",
                htmlContainer: "no-padding-container swal-html-width-100",
                confirmButton:
                    "btn btn-info btn-ktb-WEB-v2 font-anuphan-bold-16 btn-swal-width-100 btn-ktb-WEB-confirm-v2 btn-ktb-WEB-confirm-v2-fixed btn-ktb-WEB-confirm-v2-buttom",
                footer: "swal-example-footer",
            },
            width: "fit-content",
            padding: "0",
            grow: "fullscreen",
            background: "linear-gradient(#EBEDF7,  #FFFFFF)",
        })
        .then((result) => {
            if (result.isConfirmed) {
                if (checkNotEmpty(objs.callback)) {
                    objs["callback"]();
                }
            }
        });
};

const createContent = (objs, height) => {
    if (!checkNotEmpty(objs) && !checkNotEmpty(height)) return;
    return `
        <div class="revamp-error-content-container" style="padding-top: calc(${height} + 7vh); height: calc(100vh - ${height});">
            ${checkNotEmpty(objs.state)
            ? `<div class="${mapCodeError(
                objs.state
            )} background-img-size"> </div>`
            : ""
        }
            ${checkNotEmpty(objs.title)
            ? `<h3 class="font-anuphan-bold-20 text-revamp-color-black">${objs.title}</h3>`
            : ""
        }
            ${checkNotEmpty(objs.detail)
            ? `<p class="font-anuphan-regular-16-400 text-revamp-color-grey pt-2">${objs.detail}</p>`
            : ""
        }
        </div>
    `;
};

export const State = {
    0: "timeout",
    1: "error",
};

const mapCodeError = (code) => {
    switch (code) {
        case State["0"]:
            return "background-img-timeout";
        case State["1"]:
        default:
            return "background-img-error";
    }
};
